import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class ReportedUserGetArgs extends BaseGetArgs<ReportedUserGetArgs> {
  @Field(t => Int)
  userId!: number

  @Field({ nullable: true })
  sinceLastRestriction?: boolean

  @Field({ nullable: true })
  ignored?: boolean

  @Field({ nullable: true })
  system?: boolean
}
